import * as React from "react";

import { Flex, FlexGap } from "@magnetic/flex";
import { Spinner } from "@magnetic/spinner";

import "./pageContent.scss";

export interface ContentProps {
  readonly classNames?: string[];
  readonly gap?: FlexGap;
  readonly children: React.ReactNode;
  readonly actions?: React.ReactNode;
  readonly emptyState?: React.ReactNode;
  readonly loading?: boolean;

  readonly titleSection?: React.ReactNode;
}
export const PageContent = (props: ContentProps) => {
  const {
    classNames = [],
    children,
    actions,
    emptyState,
    titleSection,
    loading,
    gap
  } = props;
  let content = undefined;
  if (loading) {
    content = (
      <Flex align="center" direction="vertical" gap={gap || 16}>
        <Spinner size="lg" />
      </Flex>
    );
  }

  if (emptyState) {
    content = emptyState;
  } else if (children) {
    content = children;
  }
  return (
    <div className={`cnc-page-content ${classNames?.join(" ")}`}>
      {(titleSection || actions) && (
        <div className="header">
          {titleSection && <div className="title-section">{titleSection}</div>}
          {actions && <div className="action-section">{actions}</div>}
        </div>
      )}
      {content}
    </div>
  );
};
